import { render, staticRenderFns } from "./PolizaTodoRiesgo.vue?vue&type=template&id=064d5a06&scoped=true"
import script from "./PolizaTodoRiesgo.vue?vue&type=script&lang=js"
export * from "./PolizaTodoRiesgo.vue?vue&type=script&lang=js"
import style0 from "./PolizaTodoRiesgo.vue?vue&type=style&index=0&id=064d5a06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064d5a06",
  null
  
)

export default component.exports